module.exports = __webpack_public_path__ + "static/media/ic_发送.f52ff27e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_发送.svg
// module id = 369
// module chunks = 0